import { useEffect, useRef } from 'preact/hooks';
import { confirmRequest } from '../store/confirm';
import { Icon } from './Icon';

export function ConfirmModal() {
  const ref = useRef<HTMLDialogElement>(null);
  const req = confirmRequest.value;

  useEffect(() => {
    const dialog = ref.current;
    if (!dialog) return;
    if (req && !dialog.open) dialog.showModal();
    if (!req && dialog.open) dialog.close();
  }, [req]);

  const settle = (ok: boolean) => {
    req?.resolve(ok);
    confirmRequest.value = null;
  };

  return (
    <dialog
      ref={ref}
      class="modal"
      onCancel={(e) => {
        e.preventDefault();
        settle(false);
      }}
    >
      {req && (
        <>
          <div class="modal-body">
            <h3
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                color: req.danger ? 'var(--danger)' : undefined,
              }}
            >
              <Icon name={req.danger ? 'triangle-alert' : 'circle-alert'} size={20} />
              {req.title}
            </h3>
            <p>{req.message}</p>
          </div>
          <div class="modal-actions">
            <button class="secondary" onClick={() => settle(false)}>
              Cancelar
            </button>
            <button
              class={req.danger ? 'danger-outline' : 'primary'}
              onClick={() => settle(true)}
            >
              Confirmar
            </button>
          </div>
        </>
      )}
    </dialog>
  );
}
